<script setup lang="ts">
import { computed } from 'vue'

import { Icon } from '@collector/shared-ui'

interface Props {
  eventId: number
}

const props = defineProps<Props>()

// computed
const url = computed(() => `${window.location.origin}/demo/${props.eventId}`)
</script>

<template>
  <a
    class="border-neutral-light-7 bg-neutral-light-7 hover:bg-neutral-light-3 hover:border-neutral-light-3 inline-flex max-h-8 min-h-8 max-w-8 min-w-8 items-center justify-center rounded-sm border"
    :href="url"
    target="_blank"
  >
    <Icon
      icon="desktop"
      size="xs"
    />
  </a>
</template>
